// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const FiscalYearCriteria = props =>
    <div className='fiscal-year-criteria'>
        <LabeledCriteria
            className='labeled-criteria'
            isRequired={true}
            label='FISCAL_YEAR'
            maxLength='4'
            onInputChange={props.handleInputChange}
            placeholder='FISCAL_YEAR'
            type='number'
            value={props.fiscalYearValue}
        />
    </div>;

FiscalYearCriteria.displayName = 'FiscalYearCriteria';
FiscalYearCriteria.propTypes = {
    fiscalYearValue: PropTypes.number,
    handleInputChange: PropTypes.func.isRequired
};

export default FiscalYearCriteria;




// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-summary-report-criteria/fiscal-year-criteria.js